import axios from "axios";
import settings from "../settings";
import { PermissionsConstants } from "@/permissions";

let new_user_data = {
    is_new: true,
    first_name: null,
    last_name: null,
    email: null,
    phone: null,
    position: null,
    role: "user",
    password: null,
    status: "pending",
    custom_links: {}
};
let new_link_data = {
    title: null,
    is_active: true,
    open_in: null,
    url: "https://"
};

let initialState = {
    loadingUserList: false,
    loadingUserData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    activeUser: {
        permissions: {}
    },
    users: [],
    searchUserString: "",
    errorMessage: "",
    allPermissions: {},
    allActions: [],
    adminRoles: [
        PermissionsConstants.PERMISSIONS_ADMIN_PRODUCT_GROUP,
        PermissionsConstants.PERMISSIONS_ADMIN_SALES_GROUP,
        PermissionsConstants.PERMISSIONS_ADMIN_WAREHOUSE_GROUP
    ],
    predefinedPermissionsByRole: {
        [PermissionsConstants.ROLE_USER]: {
            [PermissionsConstants.WORK_ORDER]: [],
            [PermissionsConstants.CLIENT]: [],
            [PermissionsConstants.EXPORT_CLIENT]: [],
            [PermissionsConstants.EXPORT]: [],
            [PermissionsConstants.INVOICE]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.PRODUCT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EXPORT,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.RULES]: [],
            [PermissionsConstants.SHOP]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.SHOPS_MAP]: [PermissionsConstants.LIST, PermissionsConstants.VIEW],
            [PermissionsConstants.UNMATCHED_SHOP]: [],
            [PermissionsConstants.USER]: []
        },
        [PermissionsConstants.ROLE_OPERATOR]: {
            [PermissionsConstants.WORK_ORDER]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT
            ],
            [PermissionsConstants.CLIENT]: [],
            [PermissionsConstants.EXPORT_CLIENT]: [],
            [PermissionsConstants.EXPORT]: [],
            [PermissionsConstants.INVOICE]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.PRODUCT]: [],
            [PermissionsConstants.RULES]: [],
            [PermissionsConstants.SHOP]: [],
            [PermissionsConstants.SHOPS_MAP]: [],
            [PermissionsConstants.UNMATCHED_SHOP]: [],
            [PermissionsConstants.USER]: []
        },
        [PermissionsConstants.ROLE_HEAD_OF_SHIFT]: {
            [PermissionsConstants.USER]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.CREATE,
                PermissionsConstants.EDIT
            ],
            [PermissionsConstants.WORK_ORDER]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.SEARCH,
                PermissionsConstants.UPLOAD
            ],
            [PermissionsConstants.CLIENT]: [],
            [PermissionsConstants.EXPORT_CLIENT]: [],
            [PermissionsConstants.EXPORT]: [],
            [PermissionsConstants.INVOICE]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.PRODUCT]: [],
            [PermissionsConstants.RULES]: [],
            [PermissionsConstants.SHOP]: [],
            [PermissionsConstants.SHOPS_MAP]: [],
            [PermissionsConstants.UNMATCHED_SHOP]: [],
            [PermissionsConstants.USER]: []
        },
        [PermissionsConstants.ROLE_LINE_WORKER]: {
            [PermissionsConstants.WORK_ORDER]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.CLIENT]: [],
            [PermissionsConstants.EXPORT_CLIENT]: [],
            [PermissionsConstants.EXPORT]: [],
            [PermissionsConstants.INVOICE]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.PRODUCT]: [],
            [PermissionsConstants.RULES]: [],
            [PermissionsConstants.SHOP]: [],
            [PermissionsConstants.SHOPS_MAP]: [],
            [PermissionsConstants.UNMATCHED_SHOP]: [],
            [PermissionsConstants.USER]: []
        },
        [PermissionsConstants.PERMISSIONS_ADMIN_PRODUCT_GROUP]: {
            [PermissionsConstants.EXPORT]: [PermissionsConstants.LIST, PermissionsConstants.VIEW],
            [PermissionsConstants.PRODUCT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.EXPORT,
                PermissionsConstants.FILTER,
                PermissionsConstants.UPLOAD,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.WORK_ORDER]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.CLIENT]: [],
            [PermissionsConstants.EXPORT_CLIENT]: [],
            [PermissionsConstants.INVOICE]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.RULES]: [],
            [PermissionsConstants.SHOP]: [],
            [PermissionsConstants.SHOPS_MAP]: [],
            [PermissionsConstants.UNMATCHED_SHOP]: [],
            [PermissionsConstants.USER]: []
        },
        [PermissionsConstants.PERMISSIONS_ADMIN_SALES_GROUP]: {
            [PermissionsConstants.CLIENT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.EXPORT_CLIENT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.EXPORT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH,
                PermissionsConstants.UPLOAD
            ],
            [PermissionsConstants.INVOICE]: [PermissionsConstants.LIST],
            [PermissionsConstants.PRODUCT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EXPORT,
                PermissionsConstants.FILTER,
                PermissionsConstants.UPLOAD,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.RULES]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.SHOP]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.SHOPS_MAP]: [PermissionsConstants.LIST, PermissionsConstants.SEARCH],
            [PermissionsConstants.UNMATCHED_SHOP]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE
            ],
            [PermissionsConstants.USER]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.WORK_ORDER]: []
        },
        [PermissionsConstants.PERMISSIONS_ADMIN_WAREHOUSE_GROUP]: {
            [PermissionsConstants.CLIENT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.EXPORT_CLIENT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.EXPORT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EDIT,
                PermissionsConstants.CREATE,
                PermissionsConstants.DELETE,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH,
                PermissionsConstants.UPLOAD
            ],
            [PermissionsConstants.INVOICE]: [PermissionsConstants.LIST],
            [PermissionsConstants.PRODUCT]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.EXPORT,
                PermissionsConstants.FILTER,
                PermissionsConstants.UPLOAD,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.SHOP]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.FILTER,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.SHOPS_MAP]: [PermissionsConstants.LIST, PermissionsConstants.SEARCH],
            [PermissionsConstants.WORK_ORDER]: [
                PermissionsConstants.LIST,
                PermissionsConstants.VIEW,
                PermissionsConstants.SEARCH
            ],
            [PermissionsConstants.USER]: [],
            [PermissionsConstants.LOG]: [],
            [PermissionsConstants.RULES]: [],
            [PermissionsConstants.UNMATCHED_SHOP]: []
        }
    }
};

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getUserList({ commit }, search = null) {
            commit("setUserListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/users", { params: search });
                if (response.status === 200) {
                    let data = response.data;
                    commit("addUsers", data.users);
                    commit("setUserListLoading", false);
                }
            } catch (e) {
                console.log(e);
                commit("setUserListLoading", false);
            }
        },
        async getUserData({ commit }, userId) {
            commit("setUserDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/user/" + userId);
                if (response && response.data) {
                    let data = response.data;
                    commit("setActiveUser", data.user_data);
                    commit("setAllPermissions", data.all_permissions);
                    commit("setAllActions", data.all_actions);
                }
                commit("setUserDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setUserDataLoading", false);
            }
        },
        async submitUserUpdate({ commit, dispatch }, payload) {
            commit("setRequestSuccess", false);
            commit("setErrorMessage", "");
            try {
                const data = payload;
                let response = await axios.post(settings.api_url + "/user/", data);
                if (response.status === 200 && response.data.success === 1) {
                    dispatch("getUserList");
                    commit("setRequestSuccess", true);
                } else if (response.data.success === 0 && response.data.error === "email_exists") {
                    commit("setErrorMessage", "Email address already exists");
                } else if (response.data.success === 0 && response.data.error === "pw_change_error") {
                    commit("setErrorMessage", "Not permitted to change password");
                }
            } catch (e) {
                console.log(e);
            }
        },
        async saveUserProductXslxColumnSettings({ commit, dispatch }, payload) {
            const data = {
                act: "save_product_xlsx_settings",
                columns: payload
            };
            try {
                await axios.post(settings.api_url + "/user/", data);
            } catch (e) {
                console.log(e);
            }
        },
        async saveUserProductSearchColumnSettings({ commit, dispatch }, payload) {
            const data = {
                act: "save_product_search_settings",
                columns: payload
            };
            try {
                await axios.post(settings.api_url + "/user/", data);
            } catch (e) {
                console.log(e);
            }
        },
        async saveUserClientSearchColumnSettings({ commit, dispatch }, payload) {
            const data = {
                act: "save_client_search_settings",
                columns: payload
            };
            try {
                await axios.post(settings.api_url + "/user/", data);
            } catch (e) {
                console.log(e);
            }
        },
        async saveUserShopsAdminTableColumnSettings({ commit, dispatch }, payload) {
            const data = {
                act: "save_shops_admin_search_settings",
                columns: payload
            };
            try {
                await axios.post(settings.api_url + "/user/", data);
            } catch (e) {
                console.log(e);
            }
        },
        async saveUserExportInvoiceSearchColumnSettings({ commit, dispatch }, payload) {
            const data = {
                act: "save_export_invoice_search_settings",
                columns: payload
            };
            try {
                await axios.post(settings.api_url + "/user/", data);
            } catch (e) {
                console.log(e);
            }
        },
        async saveUserWorkOrdersTableColumnSettings({ commit, dispatch }, payload) {
            const data = {
                act: "save_work_orders_table_settings",
                columns: payload
            };
            try {
                await axios.post(settings.api_url + "/user/", data);
            } catch (e) {
                console.log(e);
            }
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addUsers(state, users) {
            state.users = users;
        },
        setActiveUser(state, user) {
            state.activeUser = { ...user };
        },
        setAllActions(state, data) {
            state.allActions = data;
        },
        setAllPermissions(state, data) {
            state.allPermissions = data;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveUser(state) {
            state.activeUser = {};
        },
        addNewUser(state) {
            state.activeUser = new_user_data;
        },
        updateActiveUserProperty(state, { prop, value }) {
            state.activeUser = {
                ...state.activeUser,
                [prop]: value
            };
        },
        updateActiveUserWorkRole(state, { prop, value, index }) {
            state.activeUser.work_roles[index] = {
                ...state.activeUser.work_roles[index],
                [prop]: value
            };
        },
        updateActiveUserCustomLinksProperty(state, { prop, value, index }) {
            state.activeUser.custom_links[index] = {
                ...state.activeUser.custom_links[index],
                [prop]: value
            };
        },
        updateUserSearch(state, payload) {
            state.searchUserString = payload.term;
            this.dispatch("UserStore/getUserList", {
                search: state.searchUserString
            });
        },
        resetUserSearch(state) {
            state.searchUserString = "";
        },
        setUserListLoading(state, value) {
            state.loadingUserList = value;
        },
        setUserDataLoading(state, value) {
            state.loadingUserData = value;
        },
        addNewLink(state) {
            if (!state.activeUser.custom_links || !state.activeUser.custom_links.length) {
                state.activeUser.custom_links = [];
            }
            state.activeUser.custom_links.push(new_link_data);
        },
        deleteLink(state, index) {
            state.activeUser.custom_links.splice(index, 1);
        },
        addPermission(state, { action, view }) {
            state.activeUser.permissions[view].push(action);
        },
        removeViewPermissions(state, { view, start, end }) {
            state.activeUser.permissions[view].splice(start, end);
        },
        resetPermissions(state) {
            for (const key in state.activeUser.permissions) {
                if (
                    state.activeUser.permissions.hasOwnProperty(key) &&
                    Array.isArray(state.activeUser.permissions[key])
                ) {
                    state.activeUser.permissions[key] = [];
                }
            }
        },
        setDefaultRolePermission(state, role) {
            const predefinedPermissions = state.predefinedPermissionsByRole[role];
            if (predefinedPermissions) {
                for (const key in predefinedPermissions) {
                    if (predefinedPermissions.hasOwnProperty(key)) {
                        if (!state.activeUser.permissions[key]) {
                            state.activeUser.permissions[key] = predefinedPermissions[key];
                        } else {
                            state.activeUser.permissions[key] = [
                                ...state.activeUser.permissions[key],
                                ...predefinedPermissions[key]
                            ];
                        }
                    }
                }
            }
        }
    },
    getters: {
        userCount: state => {
            return state.users?.length;
        }
    }
};
